export default __webpack_public_path__ + "static/strikefinance-ad7685f5c272fcd6af1daefdf19306cf.jpg";